<template>
  <div id="login">
    <div id="logo">
      <a href="https://www.bigvisiontech.com/" target="_blank"
        ><img src="../assets/images/logo.png" alt=""
      /></a>
    </div>
    <div id="login_box">
      <div class="login">
        <div class="login_left completeInfo_left">
          <div
            class="login_l_title completeInfo_l_title"
            v-if="bindExistsAccount == false"
          >
            <el-steps :active="steps" finish-status="success" align-center>
              <!-- <el-step :title="i.value" v-for="(i, index) in stepArr" :key="index" v-if="i.show"></el-step> -->
              <el-step
                :title="i.value"
                v-for="(i, index) in stepArr"
                :key="index"
              ></el-step>
            </el-steps>
          </div>
          <div
            class="login_l_title completeInfo_l_title bindExistsAccount"
            v-if="bindExistsAccount"
          >
            <span class="active">绑定已有账号</span>
          </div>

          <div class="completeInfo_main">
            <!-- 完善账号信息 -->
            <div v-if="perfectAccountInfo">
              <!-- 选择方式 -->
              <div class="completeInfo_m_account" v-if="chooseAccountModal">
                <!-- <div class="completeInfo_m_acc_title">完善账号信息</div> -->
                <div class="completeInfo_m_acc_main">
                  <div class="completeInfo_m_acc_m_li">
                    <el-button type="primary" @click="bindAccountFun()"
                      >绑定已有账号</el-button
                    >
                  </div>
                  <div class="completeInfo_m_acc_m_li_img">
                    <img src="../assets/images/loop.png" alt="" />
                  </div>
                  <div class="completeInfo_m_acc_m_li">
                    <el-button type="primary" @click="newAccountFun()"
                      >创建新账号</el-button
                    >
                  </div>
                </div>
              </div>
              <!-- 绑定账号  -->
              <div
                id="bindAccountModal"
                class="completeInfo_m_account"
                v-if="bindAccountModal"
              >
                <!-- <div class="completeInfo_m_acc_title">绑定账号</div> -->
                <div class="completeInfo_m_acc_main">
                  <div class="login_l_tel clearFix">
                    <div
                      class="login_l_t_r w1 fl_r"
                      :class="
                        searchAccount_errShow
                          ? searchAccount_col
                            ? 'bor_green'
                            : 'bor_red'
                          : ''
                      "
                    >
                      <el-input
                        name="accountName"
                        autocomplete="new-password"
                        onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false"
                        v-model="accountName"
                        placeholder="请输入账号名/手机号"
                        @focus="accountName_focus"
                        @blur="accountName_blur"
                      ></el-input>
                      <span class="login_l_getCode" @click="searchAccount()"
                        >搜索</span
                      >
                      <p
                        class="login_err_tips"
                        :class="searchAccount_col ? 'col_green' : 'col_red'"
                        v-if="searchAccount_errShow"
                      >
                        {{ searchAccount_errMsg }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="login_l_pwd mt30"
                    :class="bindAccount_telCode_errShow ? 'bor_red' : ''"
                    v-if="bindAccount_telCode_show"
                  >
                    <el-input
                      id="bindAccount_telCode"
                      name="bindAccount_telCode"
                      autocomplete="new-password"
                      onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false"
                      @keyup.enter.native="submit_bindAccount()"
                      v-model="bindAccount_telCode"
                      placeholder="请输入验证码"
                      @focus="bindAccount_telCode_focus()"
                      @blur="bindAccount_telCode_blur()"
                    ></el-input>
                    <span
                      class="login_l_getCode"
                      :class="mobile.length === 11 ? 'lightText' : ''"
                      v-if="getCodeBtn"
                      @click="getCode_bindAccount()"
                      >获取验证码</span
                    >
                    <span class="login_l_getCode" v-else
                      >倒计时<span>{{ time }}</span
                      >s</span
                    >
                    <p
                      class="login_err_tips col_red"
                      v-if="bindAccount_telCode_errShow"
                    >
                      {{ bindAccount_telCode_errMsg }}
                    </p>
                  </div>
                  <div
                    class="login_l_pwd mt30"
                    :class="accountPwd_errShow ? 'bor_red' : ''"
                    v-if="accountPwd_show"
                  >
                    <el-input
                      id="accountPwd"
                      name="accountPwd"
                      autocomplete="new-password"
                      onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false"
                      @keyup.enter.native="submit_bindAccount()"
                      v-model="accountPwd"
                      show-password
                      placeholder="请输入密码"
                      @focus="accountPwd_focus"
                      @blur="accountPwd_blur"
                    ></el-input>
                    <p class="login_err_tips col_red" v-if="accountPwd_errShow">
                      {{ accountPwd_errMsg }}
                    </p>
                  </div>
                  <div class="login_l_bottom btn2 clearFix">
                    <el-button
                      type="primary"
                      :class="
                        accountPwd_show || bindAccount_telCode_show
                          ? 'fl_l'
                          : ''
                      "
                      @click="backChooseAccount()"
                      >取消</el-button
                    >
                    <el-button
                      type="primary"
                      :class="
                        accountPwd_show || bindAccount_telCode_show
                          ? 'fl_r'
                          : ''
                      "
                      @click="submit_bindAccount()"
                      v-if="accountPwd_show || bindAccount_telCode_show"
                      >确定</el-button
                    >
                  </div>
                </div>
              </div>
              <!-- 创建新账号 -->
              <div
                id="newAccountModal"
                class="completeInfo_m_account"
                v-if="newAccountModal"
              >
                <div class="completeInfo_m_acc_main">
                  <div
                    class="login_l_pwd"
                    :class="searchNewAccount_errShow ? 'bor_red' : ''"
                  >
                    <el-input
                      name="newAccountName"
                      autocomplete="new-password"
                      onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false"
                      v-model="newAccountName"
                      maxlength="20"
                      placeholder="请输入账号名(字母开头4~16位,字母、数字及下划线)"
                      @focus="newAccount_focus()"
                      @blur="newAccount_blur()"
                    ></el-input>
                    <p
                      class="login_err_tips col_red"
                      v-if="searchNewAccount_errShow"
                    >
                      {{ searchNewAccount_errMsg }}
                    </p>
                  </div>
                  <div
                    class="login_l_pwd mt30"
                    :class="searchNewAccountPwd_errShow ? 'bor_red' : ''"
                  >
                    <el-input
                      name="newAccountPwd"
                      autocomplete="new-password"
                      onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false"
                      v-model="newAccountPwd"
                      show-password
                      placeholder="请输入密码"
                      @focus="newAccountPwd_focus()"
                      @blur="newAccountPwd_blur()"
                    ></el-input>
                    <p
                      class="login_err_tips col_red"
                      v-if="searchNewAccountPwd_errShow"
                    >
                      {{ searchNewAccountPwd_errMsg }}
                    </p>
                  </div>
                  <div
                    class="login_l_pwd mt30"
                    :class="searchNewAccountRePwd_errShow ? 'bor_red' : ''"
                  >
                    <el-input
                      name="newAccountRePwd"
                      autocomplete="new-password"
                      onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                      @keyup.enter.native="submitAccount()"
                      v-model="newAccountRePwd"
                      show-password
                      placeholder="请重复密码"
                      @focus="newAccountRePwd_focus()"
                      @blur="newAccountRePwd_blur()"
                    ></el-input>
                    <p
                      class="login_err_tips col_red"
                      v-if="searchNewAccountRePwd_errShow"
                    >
                      {{ searchNewAccountRePwd_errMsg }}
                    </p>
                  </div>
                  <div class="login_l_bottom btn2 clearFix">
                    <el-button
                      type="primary"
                      class="fl_l"
                      @click="backChooseAccount()"
                      v-if="newAccount_cancleBtn"
                      >取消</el-button
                    >
                    <el-button
                      type="primary"
                      :class="newAccount_cancleBtn ? 'fl_r' : ''"
                      @click="submitAccount()"
                      >确定</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 完善联系方式 -->
            <div v-if="perfectTelInfo">
              <!-- 选择方式 -->
              <div class="completeInfo_m_account" v-if="chooseTel">
                <!-- <div class="completeInfo_m_acc_title">完善联系方式</div> -->
                <div class="completeInfo_m_acc_main">
                  <div class="completeInfo_m_acc_m_li">
                    当前账号手机号为：123456789
                  </div>
                  <div class="completeInfo_m_acc_m_li">
                    <el-button plain @click="bindTelFun()"
                      >使用该手机号</el-button
                    >
                  </div>
                  <p>或</p>
                  <div class="completeInfo_m_acc_m_li">
                    <el-button plain @click="changeTelFun()"
                      >更改手机号</el-button
                    >
                  </div>
                </div>
              </div>
              <!-- 绑定联系方式  -->
              <div
                id="bindTelModal"
                class="completeInfo_m_account"
                v-if="bindTelModal"
              >
                <div class="completeInfo_m_acc_main">
                  <div class="login_l_tel clearFix">
                    <div
                      class="login_l_t_r w1 fl_r"
                      :class="searchTel_errShow ? 'bor_red' : ''"
                    >
                      <el-input
                        id="mobile"
                        type="number"
                        name="mobile"
                        autocomplete="new-password"
                        onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false"
                        v-model="mobile"
                        placeholder="请输入手机号"
                        @focus="mobile_focus()"
                        @blur="mobile_blur()"
                      ></el-input>
                      <span
                        class="login_l_getCode"
                        :class="mobile.length === 11 ? 'lightText' : ''"
                        v-if="getCodeBtn"
                        @click="getCode()"
                        >获取验证码</span
                      >
                      <span class="login_l_getCode" v-else
                        >倒计时<span>{{ time }}</span
                        >s</span
                      >
                      <!-- <p class="login_tel_tips" v-if="login_pwd_tel_tips">验证完成后，可以使用该手机号登录或找回密码</p> -->
                      <p
                        class="login_err_tips col_red"
                        v-if="searchTel_errShow"
                      >
                        {{ searchTel_errMsg }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="login_l_pwd mt30"
                    :class="searchTelCode_errShow ? 'bor_red' : ''"
                  >
                    <el-input
                      id="telCode"
                      name="telCode"
                      autocomplete="new-password"
                      onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false"
                      @keyup.enter.native="submitMobile()"
                      v-model="telCode"
                      placeholder="请输入验证码"
                      @focus="telCode_focus()"
                      @blur="telCode_blur()"
                    ></el-input>
                    <p
                      class="login_err_tips col_red"
                      v-if="searchTelCode_errShow"
                    >
                      {{ searchTelCode_errMsg }}
                    </p>
                  </div>
                  <div class="login_l_bottom btn2 clearFix">
                    <el-button type="primary" @click="submitMobile()"
                      >确定</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 关联微信账号 -->
            <div v-if="perfectWechatInfo">
              <div class="completeInfo_m_account">
                <!-- <div class="completeInfo_m_acc_title">关联微信账号</div> -->
                <div class="completeInfo_m_acc_main">
                  <div id="wechat">微信二维码</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a href="https://www.bigvisiontech.com/" target="_blank" id="footer"
      >苏州比格威医疗科技有限公司荣誉出品</a
    >
  </div>
</template>
<script>
import {
  checkBindAccount,
  bindExistsAccount,
  bindExistsAccountByMobile,
  checkUsernameUser,
  checkMobileUse,
  completeAccount,
  completeAccountInfo,
  modifyAccountMobile,
  sendModifyMobileSmsVerifyCode,
  sendBindSmsVerifyCode,
  getWxLoginUrlParams,
  handleComplete,
  getWxBindUrlParams,
  logout
} from '../api/api'
import '@/js/wxLogin'
import { _debounce } from '@/js/debounce'
import {
  getUrlSearch,
  setCodeToHeaders,
  isEmpty,
  isMobileNum,
  isValidPassword,
  regExpInp
} from '@/js/common'
export default {
  name: 'CompleteInfo2',
  data() {
    return {
      steps: 0,
      stepArr: [],
      stepArr2: [
        {
          value: '完善账号信息',
          remark: 'username',
          show: false
        },
        {
          value: '完善联系方式',
          remark: 'mobile',
          show: false
        },
        {
          value: '关联微信账号',
          remark: 'scanCode',
          show: false
        }
      ],
      perfectAccountInfo: false,
      perfectTelInfo: false,
      perfectWechatInfo: false,
      chooseAccountModal: false,
      bindAccountModal: false,
      newAccountModal: false,
      accountName: '',
      accountPwd: '',
      bindExistsAccount: false,
      accountPwd_show: false,
      searchAccount_col: true,
      searchAccount_errShow: false,
      searchAccount_errMsg: '',
      bindAccount_telCode: '',
      bindAccount_telCode_show: false,
      bindAccount_telCode_errShow: false,
      bindAccount_telCode_errMsg: '',
      accountPwd_errShow: false,
      accountPwd_errMsg: '',
      searchNewAccount_errShow: false,
      searchNewAccount_errMsg: '',
      searchNewAccountPwd_errShow: false,
      searchNewAccountPwd_errMsg: '',
      searchNewAccountRePwd_errShow: false,
      searchNewAccountRePwd_errMsg: '',
      newAccountName: '',
      newAccountPwd: '',
      newAccount_cancleBtn: true,
      newAccountRePwd: '',
      chooseTel: false,
      bindTelModal: false,
      mobile: '',
      telCode: '',
      getCodeBtn: true,
      time: 60,
      searchTel_errShow: false,
      searchTel_errMsg: '',
      searchTelCode_errShow: false,
      searchTelCode_errMsg: '',
      account_reg: {
        username: false,
        password: false,
        RePassword: false
      },
      mobile_reg: {
        mobile: false,
        code: false
      },
      loginWay: '',
      checkBindAccount_arr: {},
      formPath: ''
    }
  },
  created() {
    this.formPath = this.$route.query.formPath

    if (this.steps == 0) {
      this.clearAll()
      this.perfectAccountInfo = true
    } else if (this.steps == 1) {
      this.clearAll()
      this.perfectTelInfo = true
    } else {
      this.clearAll()
      this.perfectWechatInfo = true
    }
  },
  async mounted() {
    // 获取地址栏的code值并存入headers中
    setCodeToHeaders(getUrlSearch('code'))
    if (getUrlSearch('error_type') == 'ALREADY_BIND') {
      this.$alert('该微信账号已绑定，请扫码登录后绑定已有账号！', '微信绑定', {
        confirmButtonText: '确定'
        // callback: action => {
        //     this.$router.push("/")
        // }
      })
    }
    // 获取完善步骤
    await completeAccountInfo().then((res) => {
      // console.log(res)
      if (res) {
        this.getLoginWay(res.loginWay)
        this.stepArrInit(res)
      } else {
        this.$router.push('/')
      }
    })
    // this.wechatCode()
  },
  methods: {
    getLoginWay(way) {
      if (way == 'USERNAME') {
        this.loginWay = '密码登录'
      } else if (way == 'MOBILE') {
        this.loginWay = '验证码登录'
      } else if (way == 'SCAN_CODE') {
        this.loginWay = '微信登录'
      }
    },
    // 获取二维码加载
    async wechatCode() {
      let re
      await getWxBindUrlParams().then((res) => {
        if (this.formPath == 'acc') {
          let url = window.location.href.split('#')[0]
          res.state = encodeURIComponent(url + '#/accountSecurity')
          console.log('url： ', encodeURIComponent(url + '#/accountSecurity'))
        }
        re = res
      })
      console.log(re)
      this.$nextTick(() => {
        var content =
          '.impowerBox .qrcode {width: 260px;}.impowerBox .title {display: none;}.impowerBox .info {width: 240px;}.impowerBox .status{width:240px;padding:0;}'
        //记住一定要注明文件类型是css
        var blob = new Blob([content], { type: 'text/css;charset=utf-8' })
        var reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = function(e) {
          var obj = new WxLogin({
            self_redirect: false,
            id: 'wechat',
            appid: re.appid,
            scope: re.scope,
            redirect_uri: re.redirect_uri,
            state: re.state,
            style: '',
            href: this.result
          })
          let iframe = document.getElementsByTagName('iframe')[0]
          iframe.sandbox =
            'allow-forms allow-same-origin allow-scripts allow-top-navigation'
        }
      })
    },
    newAccount_focus() {
      this.searchNewAccount_errShow = false
      this.searchNewAccount_errMsg = ''
    },
    // new账号名框blur
    newAccount_blur() {
      if (isEmpty(this.newAccountName)) {
        this.searchNewAccount_errShow = true
        this.searchNewAccount_errMsg = '账号名不为空'
        this.account_reg.username = false
      } else {
        this.searchNewAccount_errShow = true
        var reg = /^[a-zA-Z][a-zA-Z0-9_]{3,15}$/
        if (regExpInp(this.newAccountName, reg)) {
          this.api_checkUsernameUser(this.newAccountName)
        } else {
          this.searchNewAccount_errMsg =
            '请输入以字母开头的字母、数字及下划线，长度4~16位的账户名'
          this.account_reg.username = false
        }
      }
    },
    // 接口调用：检验账号名是否存在
    api_checkUsernameUser(username) {
      checkUsernameUser(username).then((res) => {
        // console.log(res)
        if (res.exists) {
          this.searchNewAccount_errMsg = res.message
          // this.newAccountName = ''
          this.account_reg.username = false
        } else {
          this.searchNewAccount_errShow = false
          this.searchNewAccount_errMsg = ''
          this.account_reg.username = true
        }
      })
    },
    newAccountPwd_focus() {
      this.searchNewAccountPwd_errShow = false
      this.searchNewAccountPwd_errMsg = ''
    },
    // new账号密码框blur
    newAccountPwd_blur() {
      if (isEmpty(this.newAccountPwd)) {
        this.searchNewAccountPwd_errShow = true
        this.searchNewAccountPwd_errMsg = '密码不为空'
        this.account_reg.password = false
      } else {
        if (isValidPassword(this.newAccountPwd)) {
          this.searchNewAccountPwd_errShow = true
          this.searchNewAccountPwd_errMsg = '密码需为8-16位字母和数字组合'
          this.account_reg.password = false
        } else {
          this.searchNewAccountPwd_errShow = false
          this.searchNewAccountPwd_errMsg = ''
          this.account_reg.password = true
        }
      }
    },
    newAccountRePwd_focus() {
      this.searchNewAccountRePwd_errShow = false
      this.searchNewAccountRePwd_errMsg = ''
    },
    // new重复账号密码框blur
    newAccountRePwd_blur() {
      if (this.newAccountPwd == this.newAccountRePwd) {
        this.account_reg.RePassword = true
        return false
      } else {
        this.searchNewAccountRePwd_errShow = true
        this.searchNewAccountRePwd_errMsg = '两次密码不一致'
        this.account_reg.RePassword = false
      }
    },
    // 搜索账号
    searchAccount() {
      if (!isEmpty(this.accountName)) {
        checkBindAccount(this.accountName).then((res) => {
          this.checkBindAccount_arr = res
          this.searchAccount_errShow = true

          if (res.result) {
            this.searchAccount_col = true
            if (res.bindWay == 'USERNAME_PASSWORD') {
              this.accountPwd_show = true
              this.bindAccount_telCode_show = false
              this.searchAccount_errMsg = '账号有效，输入密码以绑定账号！'
            }
            if (res.bindWay == 'MOBILE') {
              this.accountPwd_show = false
              this.bindAccount_telCode_show = true
              this.searchAccount_errMsg = '账号有效，获取验证码以绑定账号！'
            }
          } else {
            this.accountPwd_show = false
            this.accountPwd = ''
            this.searchAccount_col = false
            this.searchAccount_errMsg = res.message
          }
        })
      }
    },
    accountName_focus() {
      this.searchAccount_errShow = false
      this.searchAccount_errMsg = ''
      this.clear_existeAccount_telCode()
      this.clear_existeAccount_pwd()
    },
    accountName_blur() {
      if (isEmpty(this.accountName)) {
        this.searchAccount_errShow = true
        this.searchAccount_col = false
        this.searchAccount_errMsg = '账号名不为空'
        return false
      } else {
        this.searchAccount_errShow = false
        this.searchAccount_errMsg = ''
        this.searchAccount()
        return true
      }
    },
    accountPwd_focus() {
      this.accountPwd_errShow = false
      this.accountPwd_errMsg = ''
    },
    accountPwd_blur() {
      if (isEmpty(this.accountPwd)) {
        this.accountPwd_errShow = true
        this.accountPwd_errMsg = '密码不为空'
        return false
      } else {
        this.accountPwd_errShow = false
        this.accountPwd_errMsg = ''
        return true
      }
    },
    // 绑定账号提交
    submit_bindAccount: _debounce(function() {
      // console.log('checkBindAccount_arr: ', this.checkBindAccount_arr)
      if (this.checkBindAccount_arr.bindWay == 'USERNAME_PASSWORD') {
        let pwd = document.getElementById('accountPwd')
        pwd.blur()
        if (this.accountPwd_blur() && this.accountName_blur()) {
          this.api_bindExistsAccount()
        }
      }
      if (this.checkBindAccount_arr.bindWay == 'MOBILE') {
        let telCode = document.getElementById('bindAccount_telCode')
        telCode.blur()
        if (this.bindAccount_telCode_blur() && this.accountName_blur()) {
          this.api_bindExistsAccountByMobile()
        }
      }
    }),
    // 接口调用：绑定已有账号
    async api_bindExistsAccount() {
      let params = {
        accountId: this.checkBindAccount_arr.id,
        password: this.accountPwd
      }
      await bindExistsAccount(params).then((res) => {
        // console.log(res)
        if (res.success) {
          if (this.checkBindAccount_arr.mobile) {
            this.api_handleComplete()
          } else {
            this.goNextOrComplete()
          }
        } else {
          // this.$message.error(res.message)
          this.accountPwd_errShow = true
          this.accountPwd_errMsg = res.message
        }
      })
    },
    // 接口调用：完成完善信息
    api_handleComplete() {
      handleComplete().then((res) => {
        // console.log(res)
        window.location.href = res
      })
    },
    // 接口调用：绑定已有账号-手机号
    async api_bindExistsAccountByMobile() {
      let params = {
        accountId: this.checkBindAccount_arr.id,
        mobile: this.accountName,
        code: this.bindAccount_telCode
      }
      await bindExistsAccountByMobile(params).then((res) => {
        // console.log(res)
        if (res.success) {
          location.reload()
        } else {
          // this.$message.error(res.message)
          this.bindAccount_telCode_errShow = true
          this.bindAccount_telCode_errMsg = res.message
        }
      })
    },
    // 接口调用：检验绑定账号
    async api_checkBindAccount(name) {
      await checkBindAccount(name).then((res) => {
        this.checkBindAccount_arr = res
        if (res.result) {
          return true
        } else {
          return false
        }
      })
    },
    // 提交账号信息
    submitAccount: _debounce(function() {
      this.newAccount_blur()
      this.newAccountPwd_blur()
      this.newAccountRePwd_blur()
      if (
        this.account_reg.username &&
        this.account_reg.password &&
        this.account_reg.RePassword
      ) {
        // console.log("提交账号信息")
        this.api_completeAccount()
      }
    }),
    // 接口调用：完善账号信息
    async api_completeAccount() {
      var params = {
        username: this.newAccountName,
        password: this.newAccountPwd
      }
      await completeAccount(params).then((res) => {
        // console.log(res)
        this.goNextOrComplete()
      })
    },
    mobile_focus() {
      this.searchTel_errShow = false
      this.searchTel_errMsg = ''
    },
    // 手机号框blur
    mobile_blur() {
      this.mobileCheck(this.mobile)
    },
    mobileCheck(tel) {
      if (isEmpty(tel)) {
        this.searchTel_errShow = true
        this.searchTel_errMsg = '手机号不为空'
      } else {
        if (isMobileNum(tel)) {
          this.searchTel_errShow = false
          this.searchTel_errMsg = ''
          this.mobile_reg.mobile = true
        } else {
          this.searchTel_errShow = true
          this.searchTel_errMsg = '手机号格式不正确'
          this.mobile_reg.mobile = false
        }
      }
    },
    checkTel(val) {
      if (val == '') {
        return false
      }

      let regTel = /^[1][3-9][0-9]{9}$/
      if (!regTel.test(val)) {
        this.mobile = ''
        this.searchTel_errShow = true
        this.searchTel_errMsg = '手机号格式不正确'
        this.mobile_reg.mobile = false
      } else {
        this.mobile_reg.mobile = true
      }
    },
    bindAccount_telCode_focus() {
      this.bindAccount_telCode_errShow = false
      this.bindAccount_telCode_errMsg = ''
    },
    bindAccount_telCode_blur() {
      if (isEmpty(this.bindAccount_telCode)) {
        this.bindAccount_telCode_errShow = true
        this.bindAccount_telCode_errMsg = '验证码不为空'
        return false
      } else {
        this.bindAccount_telCode_errShow = false
        this.bindAccount_telCode_errMsg = ''
        return true
      }
    },
    telCode_focus() {
      this.searchTelCode_errShow = false
      this.searchTelCode_errMsg = ''
    },
    telCode_blur() {
      this.telCode = this.removeAllSpace(this.telCode)
      if (this.telCode) {
        this.mobile_reg.code = true
        this.searchTelCode_errShow = false
        this.searchTelCode_errMsg = ''
      } else {
        this.searchTelCode_errShow = true
        this.searchTelCode_errMsg = '验证码不为空'
        this.mobile_reg.code = false
      }
    },
    searchTel() {
      checkMobileUse(this.mobile).then((res) => {
        this.searchTel_errShow = true
        if (res.exists) {
          this.searchTel_errMsg = res.message
        }
      })
    },
    // 获取验证码
    getCode_bindAccount() {
      sendBindSmsVerifyCode(this.accountName).then((res) => {
        // console.log('获取验证码: ', res)
        this.getCodeBtn = false
        this.coutDown()
      })
    },
    // 获取验证码
    getCode() {
      if (this.mobile_reg.mobile) {
        sendModifyMobileSmsVerifyCode(this.mobile).then((res) => {
          // console.log('获取验证码: ', res)
          this.getCodeBtn = false
          this.coutDown()
        })
      } else {
        this.$message({
          showClose: true,
          message: '请正确填写手机号！',
          type: 'error'
        })
      }
    },
    coutDown() {
      var that = this
      var timeClock = setInterval(function() {
        that.time--

        if (that.time == 0) {
          that.getCodeBtn = true
          clearInterval(timeClock)
          that.time = 60
        }
      }, 1000)
    },
    // 提交联系方式
    submitMobile: _debounce(function() {
      this.mobile_blur()
      this.telCode_blur()
      if (this.mobile_reg.mobile && this.mobile_reg.code) {
        this.api_modifyAccountMobile()
      }
    }),
    // 接口请求：完善联系方式
    async api_modifyAccountMobile() {
      var params = {
        mobile: this.mobile,
        code: this.telCode
      }
      await modifyAccountMobile(params).then(
        (res) => {
          // console.log(res)
          this.$message({
            showClose: true,
            message: '提交成功',
            type: 'success'
          })

          this.goNextOrComplete()
        },
        (error) => {
          if (error.data.handleWay == 'Input') {
            let telCode = document.getElementById('telCode')
            telCode.blur()
            this.searchTelCode_errShow = true
            this.searchTelCode_errMsg = error.data.message
          }
          let that = this
          if (error.data.message == '该手机号已被绑定！') {
            this.$confirm('是否退出当前登录?', '提示', {
              confirmButtonText: '退出',
              cancelButtonText: '返回',
              type: 'warning'
            })
              .then(() => {
                logout().then((res) => {
                  this.$router.push('/login')
                })
              })
              .catch(() => {
                console.log('不退出')
              })
          }
        }
      )
    },
    perfectAccountFun(val) {
      this.clearAll()
      this.perfectAccountInfo = true
      if (val) {
        this.chooseAccountModal = true
      } else {
        this.newAccountFun()
      }
    },
    perfectTelFun() {
      this.clearAll()
      this.perfectTelInfo = true
      this.bindTelFun()
    },
    perfectWechatFun() {
      this.clearAll()
      this.perfectWechatInfo = true
    },
    bindAccountFun() {
      this.clearAccountAll()
      this.clear_existeAccountAll()
      this.bindAccountModal = true
      this.bindExistsAccount = true
    },
    newAccountFun() {
      this.clearAccountAll()
      this.clear_newAccountAll()
      this.newAccountModal = true
    },
    backChooseAccount() {
      this.clearAccountAll()
      this.chooseAccountModal = true
    },
    //清除--账号相关【选择、绑定已有账号、创建新账号】
    clearAccountAll() {
      this.chooseAccountModal = false
      this.bindAccountModal = false
      this.newAccountModal = false
      this.bindExistsAccount = false
    },
    // 清除--绑定已有账号【所有输入框内容及错误信息】
    clear_existeAccountAll() {
      this.clear_existeAccount_name()
      this.clear_existeAccount_telCode()
      this.clear_existeAccount_pwd()
    },
    // 清除--绑定已有账号【账号输入框】
    clear_existeAccount_name() {
      this.accountName = ''
      this.searchAccount_errShow = false
      this.searchAccount_col = true
      this.searchAccount_errMsg = ''
    },
    // 清除--绑定已有账号【验证码输入框】
    clear_existeAccount_telCode() {
      this.bindAccount_telCode = ''
      this.bindAccount_telCode_show = false
      this.bindAccount_telCode_errShow = false
      this.bindAccount_telCode_errMsg = ''
    },
    // 清除--绑定已有账号【密码输入框】
    clear_existeAccount_pwd() {
      this.accountPwd_show = false
      this.accountPwd = ''
      this.accountPwd_errShow = false
      this.accountPwd_errMsg = ''
    },

    clear_newAccountAll() {
      this.clear_newAccount_name()
      this.clear_newAccount_pwd()
      this.clear_newAccount_rePwd()
    },
    // 清除--创建新账号【账号名输入框】
    clear_newAccount_name() {
      this.newAccountName = ''
      this.searchNewAccount_errShow = false
      this.searchNewAccount_errMsg = ''
    },
    // 清除--创建新账号【密码输入框】
    clear_newAccount_pwd() {
      this.newAccountPwd = ''
      this.searchNewAccountPwd_errShow = false
      this.searchNewAccountPwd_errMsg = ''
    },
    // 清除--创建新账号【重复密码输入框】
    clear_newAccount_rePwd() {
      this.newAccountRePwd = ''
      this.searchNewAccountRePwd_errShow = false
      this.searchNewAccountRePwd_errMsg = ''
    },
    bindTelFun() {
      this.clearTelAll()
      this.bindTelModal = true
    },
    changeTelFun() {
      this.clearTelAll()
      this.bindTelModal = true
    },
    backChooseTel() {
      this.clearTelAll()
      this.chooseTel = true
    },
    clearTelAll() {
      this.chooseTel = false
      this.bindTelModal = false
    },
    clearAll() {
      this.perfectAccountInfo = false
      this.perfectTelInfo = false
      this.perfectWechatInfo = false
    },
    removeAllSpace(value) {
      if (value) {
        return value.replace(/\s+/g, '')
      } else {
        return value
      }
    },
    stepArrInit(res) {
      this.stepArr = this.stepArr2
      this.clearAll()
      if (res.needUsername) {
        this.addShow('username')
      } else {
        this.newStepArr('username')
      }
      if (res.needMobile) {
        this.addShow('mobile')
      } else {
        this.newStepArr('mobile')
      }
      if (res.needScanCode) {
        this.addShow('scanCode')
      } else {
        this.newStepArr('scanCode')
      }

      if (res.needUsername) {
        if (res.supportBind) {
          this.perfectAccountFun('supportBind')
        } else {
          this.perfectAccountFun()
          this.newAccount_cancleBtn = false
        }
      } else if (res.needMobile) {
        this.perfectTelFun()
      } else if (res.needScanCode) {
        this.perfectWechatFun()
        this.wechatCode()
      }
    },
    addShow(name) {
      for (let i = 0; i < this.stepArr.length; i++) {
        if (this.stepArr[i].remark == name) {
          this.stepArr[i].show = true
          return
        }
      }
    },
    newStepArr(name) {
      for (let i = 0; i < this.stepArr.length; i++) {
        if (this.stepArr[i].remark == name) {
          this.stepArr.splice(i, 1)
          // console.log(this.stepArr)
          return
        }
      }
    },
    goNextOrComplete() {
      if (this.steps >= this.stepArr.length - 1) {
        this.api_handleComplete()
      } else {
        this.steps++
        this.stepContent(this.stepArr[this.steps].remark)
      }
    },
    stepContent(name) {
      if (name == 'username') {
        this.perfectAccountFun()
      } else if (name == 'mobile') {
        this.perfectTelFun()
      } else if (name == 'scanCode') this.perfectWechatFun()
      this.wechatCode()
    }
  }
}
</script>
<style scoped>
@import url('../assets/css/base.css');
@import url('../assets/css/login.css');
</style>
